import { Component, Input } from '@angular/core'
import { AnalyticsService } from '@app/core/_services/analytics.service'
import { SystemBannerService } from '@app/core/_services/system-banner.service'
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import { MessageModule } from 'primeng/message'

@Component({
    selector: 'fm-system-banner',
    templateUrl: './system-banner.component.html',
    imports: [FontAwesomeModule, MessageModule],
})
export class SystemBannerComponent {
    @Input() banner: string
    faTimes = faTimes
    public isNewLayout: boolean
    constructor(
        private analyticsService: AnalyticsService,
        private systemBannerService: SystemBannerService,
    ) {}

    onClickDismissBanner() {
        this.systemBannerService.dismissBanner()
    }

    ngOnInit(): void {
        this.analyticsService.logViewedBannerEvent('System Banner')
    }
}
